import { kanaToRomaji } from "../../utils/kanaToRomaji";

export const SEARCH_IDLE_DELAY_MS = 3000;

const LETTER_OR_DIGIT = /[\p{L}\p{N}]/u;
const SINGLE_KANJI = /^(?!々)\p{Script=Han}$/u;
const HAS_KANA = /[\u3040-\u30ff]/;

// Spaces and punctuation never count: the matcher ignores them too, so "a." is still one letter.
// A lone kanji is a whole word (水), unlike a lone Latin letter, digit or kana.
export function isSearchable(query: string): boolean {
    const characters = Array.from(query.normalize("NFKC")).filter((character) => LETTER_OR_DIGIT.test(character));
    if (characters.length === 1) return SINGLE_KANJI.test(characters[0]);
    return characters.length > 1;
}

// Keep punctuation and spacing out of comparison, but retain Japanese diacritics.
export const normalize = (value: string) => String(value || "").normalize("NFKC").replace(/[A-Za-zÀ-ÖØ-öø-ÿ]/g, (letter) => letter.normalize("NFKD").replace(/[\u0300-\u036f]/g, "")).toLocaleLowerCase().replace(/[\s~〜・、。,.!?！？…\-–—_'"()（）]/g, "");

// kanaToRomaji only rewrites kana, so text without any is normalized once. The same terms are compared on every search, so the result is cached.
const formsCache = new Map<string, readonly string[]>();
export function forms(value: string): readonly string[] {
    const text = String(value || "");
    const cached = formsCache.get(text);
    if (cached) return cached;
    const result = (HAS_KANA.test(text) ? [normalize(text), normalize(kanaToRomaji(text))] : [normalize(text)]).filter(Boolean);
    formsCache.set(text, result);
    return result;
}
